import React from 'react';
import { Modal, Box, Typography, Button, CircularProgress } from '@mui/material';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title?: string;
    message?: string;
    isLoading?: boolean; // ✅ already added
}

const ConfirmationModal: React.FC<Props> = ({
                                                isOpen,
                                                onClose,
                                                onConfirm,
                                                title = 'Confirm Action',
                                                message = 'Are you sure you want to proceed?',
                                                isLoading = false, // ✅ default false
                                            }) => {
    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box
                sx={{
                    padding: 3,
                    backgroundColor: 'white',
                    margin: 'auto',
                    marginTop: '10%',
                    width: 400,
                    borderRadius: 2,
                }}
            >
                <Typography variant="h6" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="body1" gutterBottom>
                    {message}
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginTop: 2,
                        gap: 2,
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={onClose}
                        disabled={isLoading} // ✅ Optional: disable Cancel too while loading
                        sx={{
                            backgroundColor: '#F44336 !important',
                            color: 'white !important',
                            '&:hover': {
                                backgroundColor: '#D32F2F !important',
                            },
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={onConfirm}
                        disabled={isLoading}
                        sx={{
                            backgroundColor: '#4CAF50 !important',
                            color: 'white !important',
                            '&:hover': {
                                backgroundColor: '#45A049 !important',
                            },
                        }}
                    >
                        {isLoading ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            'Confirm'
                        )}
                    </Button>

                </Box>
            </Box>
        </Modal>
    );
};

export default ConfirmationModal;
